import { INavigations } from '@/types/INavigations';
import {
  AudioOutlined,
  CoffeeOutlined,
  CreditCardOutlined,
  OrderedListOutlined,
  PictureOutlined,
  UnorderedListOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';

// token
export const AUTH_TOKEN = 'drink_token';

// pages
export const RANDOM_SLUG = '/panel0207';

export const HOME_PAGE = `${RANDOM_SLUG}`;
export const PRIVACY_POLICY_PAGE = `${RANDOM_SLUG}/privacy_policy`;

export const GREATE_COCKTAIL_PAGE = `${RANDOM_SLUG}/add_cocktail`;
export const COCKTAILS_PAGE = `${RANDOM_SLUG}/view_cocktails`;
export const EDIT_COCKTAIL_PAGE = `${RANDOM_SLUG}/edit_coctail`;
export const VIEW_COCKTAIL_PAGE = `${RANDOM_SLUG}/view_coctail`;

export const CREATE_GAME_CARD_PAGE = `${RANDOM_SLUG}/create_game_card`;
export const GAME_CARDS_PAGE = `${RANDOM_SLUG}/game_cards`;
export const EDIT_GAME_CARD_PAGE = `${RANDOM_SLUG}/game_card_edit`;
export const VIEW_GAME_CARD_PAGE = `${RANDOM_SLUG}/game_card_view`;

export const IMAGES_PAGE = `${RANDOM_SLUG}/images`;
export const VIDEO_PAGE = `${RANDOM_SLUG}/video`;
export const AUDIO_PAGE = `${RANDOM_SLUG}/audio`;

//navigations
export const profileNavigation: INavigations[] = [
  {
    id: 2,
    title: 'Create cocktail',
    link: GREATE_COCKTAIL_PAGE,
    icon: <CoffeeOutlined />,
  },
  {
    id: 1,
    title: 'Cocktails',
    link: COCKTAILS_PAGE,
    icon: <UnorderedListOutlined />,
  },
  {
    id: 5,
    title: 'Create game card',
    link: CREATE_GAME_CARD_PAGE,
    icon: <CreditCardOutlined />,
  },
  {
    id: 6,
    title: 'Game cards',
    link: GAME_CARDS_PAGE,
    icon: <OrderedListOutlined />,
  },
  {
    id: 3,
    title: 'Images',
    link: IMAGES_PAGE,
    icon: <PictureOutlined />,
  },
  {
    id: 4,
    title: 'Video',
    link: VIDEO_PAGE,
    icon: <VideoCameraOutlined />,
  },
  {
    id: 7,
    title: 'Audio',
    link: AUDIO_PAGE,
    icon: <AudioOutlined />,
  },
];
